@if (profileMenu) {
  <span class="Profile-logout">
    <span
      class="Profile-logoutLink"
      (click)="logout()">
      {{ 'APP_PROFILE_DROPDOWN_LOGOUT_LABEL' | translate }}
    </span>
    <app-nav-button
      class="Profile-logoutButton"
      [icon]="['fas', 'sign-out']"
      [title]="'APP_PROFILE_DROPDOWN_LOGOUT_LABEL'"
      (clickEvent)="logout()">
    </app-nav-button>
  </span>
} @else {
  @defer (when !profileMenu) {
    <a
      class="imp-link ProfileDropdown-userBadge"
      #profileDropdownAvatar
      tabindex="0"
      [title]="'TOPBAR_BUTTON_PROFILE_TITLE' | translate"
      (keydown.enter)="openUserMenu($event)"
      (click)="openUserMenu($event)">
      @if (loggedAsSupportUser$ | async) {
        <imp-icon-avatar
          class="ProfileDropdown-supportUser"
          icon="user-bounty-hunter"
          [impContextMenu]="supportUserContextMenu"
          [title]="'APP_PROFILE_DROPDOWN_SUPPORT_USER_LABEL' | translate"
          [style]="'smallBordered'"
          (click)="$event.stopPropagation()"></imp-icon-avatar>
      } @else {
        <imp-image-avatar
          class="ProfileDropdown-userImage"
          [impContextMenu]="contextMenu"
          [text]="user?.displayName"
          [url]="userImageUrl$ | async"
          [style]="'smallBordered'"
          (click)="$event.stopPropagation()">
        </imp-image-avatar>
      }
    </a>
    <ng-template #contextMenu>
      <div (keydown.escape)="menuClosedByEscape()">
        <imp-context-menu-item
          [label]="'APP_PROFILE_DROPDOWN_GO_TO_PROFILE_LABEL' | translate"
          [icon]="['fal', 'sync']"
          (action)="goToProfilePage()">
        </imp-context-menu-item>
        <imp-context-menu-item
          *app-permission="MANAGE_INST_PERSONNEL_VIEW_BASIC"
          [label]="'APP_PROFILE_DROPDOWN_GO_TO_EMPLOYEE_PROFILE_LABEL' | translate"
          [icon]="['fal', 'portrait']"
          (action)="goToEmployeePage()">
        </imp-context-menu-item>
        @if (companyEmployees?.length > 1) {
          <imp-context-menu-item
            [label]="'APP_PROFILE_DROPDOWN_V4_COMPANY_LABEL' | translate"
            [icon]="'building'"
            (action)="openV4CompanyModal()">
          </imp-context-menu-item>
        }
        <imp-context-menu-item
          *app-mobile
          [label]="'HELP_CENTER_DROPDOWN_LABEL' | translate"
          [icon]="['fal', 'question-circle']"
          (action)="goToHelpCenter()">
        </imp-context-menu-item>
        <imp-context-menu-item
          [label]="'APP_PROFILE_DROPDOWN_LOGOUT_LABEL' | translate"
          [icon]="['fal', 'sign-out']"
          (action)="logout()">
        </imp-context-menu-item>
      </div>
    </ng-template>
    <ng-template #supportUserContextMenu>
      <div (keydown.escape)="menuClosedByEscape()">
        <imp-context-menu-item
          [label]="'APP_PROFILE_DROPDOWN_LOGOUT_LABEL' | translate"
          [icon]="['fal', 'sign-out']"
          (action)="logoutToMM()">
        </imp-context-menu-item>
      </div>
    </ng-template>
  }
}
